import { action, observable, computed, autorun } from "mobx";
import axios from "axios";
import asyncPool from "tiny-async-pool";

import { getParcels, searchPerson, searchPersonByInsz, searchCompanyByName, searchCompanyByNumber, getMagdaParcelExists } from "services/api";
import NotifierStore from "views/notifier/NotifierStore";

const CancelToken = axios.CancelToken;
export default class searchModel {
  @observable
  persons = [];

  @observable
  parcels = [];

  @observable
  personParcels = [];

  @observable
  activeOfficialId;

  @observable
  loading = false;

  @observable
  source;

  @action
  searchPerson = async (type, firstname = "", lastname = "", year = "") => {
    this.loading = true;
    this.persons = [];
    const { data } = await searchPerson(type, firstname, lastname, year);
    this.persons = data;
    this.loading = false;
  };

  @action
  searchPersonByInsz = async (type, insz) => {
    this.loading = true;
    this.persons = [];
    const { data } = await searchPersonByInsz(type, insz);
    this.persons = data;
    this.loading = false;
  };

  @action
  searchCompanyByName = async (type, name) => {
    this.loading = true;
    this.persons = [];
    const { data } = await searchCompanyByName(type, name);
    this.persons = data;
    this.loading = false;
  };

  @action
  searchCompanyByNumber = async (type, insz) => {
    this.loading = true;
    this.persons = [];
    const { data } = await searchCompanyByNumber(type, insz);
    this.persons = data;
    this.loading = false;
  };

  @action
  searchMagdaParcelExists = async (capakey) => {
    this.loading = true;
    this.parcels = [];
    const { data } = await getMagdaParcelExists(capakey);
    if (data === true) {
      this.parcels.push({ capakey });
    }
    this.loading = false;
    return data;
  };

  @action
  getParcels = async (type, officialId, afdeling = null, departments = null) => {
    if (this.loading && this.source) {
      this.source.cancel("Operation canceled by the user.");
    }
    this.source = CancelToken.source();
    this.loading = true;
    this.activeOfficialId = officialId;
    this.personParcels = [];

    try {
      if (!afdeling && departments && departments.length > 0) {
        const results = await asyncPool(5, departments, async (dept) => {
          const res = await getParcels(type, officialId, dept.departmentCode, this.source);
          return { ...res, department: dept };
        });
        this.personParcels = results.flatMap((r) => r.data || []);
        const deptUitzonderingen = results.filter((r) => r.uitzonderingen?.length > 0);
        if (deptUitzonderingen.length > 0) {
          this._showUitzonderingenPerDepartment(deptUitzonderingen);
        }
      } else {
        const result = await getParcels(type, officialId, afdeling, this.source);
        this.personParcels = result.data;
        if (result.uitzonderingen) {
          this._showUitzonderingen(result.uitzonderingen);
        }
      }
    } catch (error) {
      if (axios.isCancel(error)) {
        console.log(error.toString());
      }
    }
    this.loading = false;
  };

  _showUitzonderingen = (uitzonderingen, departmentLabel) => {
    const messages = uitzonderingen.map((u) => u.Diagnose);
    if (departmentLabel) {
      messages.unshift(departmentLabel);
    }
    NotifierStore.enqueueSnackbar({
      message: { title: "Melding van Magda", message: messages, isExpanded: true },
      options: {
        key: new Date().getTime() + Math.random(),
        persist: true,
      },
    });
  };

  _showUitzonderingenPerDepartment = (deptResults) => {
    const messages = deptResults.flatMap((r) =>
      r.uitzonderingen.map((u) => ({
        label: `${r.department.departmentName} (${r.department.departmentCode})`,
        text: u.Diagnose,
      }))
    );
    NotifierStore.enqueueSnackbar({
      message: { title: "Melding van Magda", message: messages, isExpanded: true },
      options: {
        key: new Date().getTime() + Math.random(),
        persist: true,
      },
    });
  };

  @action
  setLoading = (value) => {
    this.loading = value;
  };

  @action
  searchPersonByInsz = async (leggerType, officialId) => {
    const { data } = await searchPersonByInsz(leggerType, officialId);
    this.activeOfficialId = officialId;
    this.persons = data;
  };

  @action
  searchCompanyByInsz = async (leggerType, officialId) => {
    const { data } = await searchCompanyByNumber(leggerType, officialId);
    this.activeOfficialId = officialId;
    this.persons = data;
  };

  @computed
  get activePerson() {
    console.log(this.persons);
    console.log(this.activeOfficialId);
    if (this.activeOfficialId) {
      const person = this.persons.find((person) => {
        return person.officialId === this.activeOfficialId;
      });
      return person;
    }
  }
}
